/*
 * @Description: 不通过弹层
 * @Date: 2021-10-29 11:34:50
 */

import noPass from '../components/no-pass.vue';
import { MessageBox, Message } from 'element-ui';
import createExtend from '@C/createExtend';

/**
 * @description: 创建不通过弹层与弹层流程处理
 * @return {promise}
 */
export default function(auditLength) {
  return new Promise((resolve, reject) => {
    const Dialog = createExtend(noPass);
    Dialog.$on('confirm', async function(e) {
      const { textarea, type } = e;
      if (textarea.length > 200) {
        Message.error('最多输入200字');
        return reject('最多输入200字');
      }
      try {
        await MessageBox.confirm(
          `<p>是否确认不通过${
            auditLength
              ? `<span style="color:#027cfa">${auditLength}</span>条`
              : ''
          }任务记录，请谨慎操作</p>`,
          {
            dangerouslyUseHTMLString: true
          }
        );
        try {
          Dialog.remove();
        } catch (e) {
          console.error(e);
        }
        resolve({ remark: textarea, type });
      } catch (e) {
        // reject(e);
      }
    });
    Dialog.$on('close', () => {
      Dialog.remove();
      // reject('close');
    });
  });
}
